import { query } from './getCheckoutSettings.graphql';
import { BaseApi, GraphQLOperations, RemoteSourceTypes } from '@wix/wixstores-client-storefront-sdk';
export class CheckoutSettingsApi extends BaseApi {
  async getCheckoutSettings() {
    const response = await this.fetch({
      query,
      variables: {},
      operationName: GraphQLOperations.GetCheckoutSettings,
      source: 'WixStoresWebClient'
    }, RemoteSourceTypes.NodeReadWrite);
    return response.data.checkoutSettings;
  }
}
//# sourceMappingURL=CheckoutSettingsApi.js.map